import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config";

function EditListing() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  // ===== SAME FIELDS AS POST LISTING (minus price + cutValue) =====
  const [suburb, setSuburb] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");

  const [accessType, setAccessType] = useState("Access Available Anytime");
  const [streetParking, setStreetParking] = useState(false);
  const [schoolZone, setSchoolZone] = useState(false);
  const [hasDogs, setHasDogs] = useState(false);
  const [greenBin, setGreenBin] = useState(false);

  const [serviceDay, setServiceDay] = useState("any");
  const [serviceTime, setServiceTime] = useState("any");

  const [time, setTime] = useState("");
  const [frequency, setFrequency] = useState("fortnightly");
  const [rideOnOrPush, setRideOnOrPush] = useState("Push");
  const [bagMulch, setBagMulch] = useState("Mulch");

  const [frontLawn, setFrontLawn] = useState(false);
  const [rearLawn, setRearLawn] = useState(false);
  const [natureStrip, setNatureStrip] = useState(false);
  const [acreage, setAcreage] = useState(false);

  const [newClient, setNewClient] = useState(false);
const [longTermClient, setLongTermClient] = useState(false);

  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);



  const token = localStorage.getItem("token");

  // ======================================================
  // LOAD LISTING DATA
  // ======================================================
  useEffect(() => {
    async function loadListing() {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/listings/${id}`);
        if (!res.data.success) {
          setMessage("❌ Failed to load listing");
          return;
        }

        const L = res.data.listings[0];

        setSuburb(L.suburb);
        setState(L.state);
        setPostcode(L.postcode);

        setAccessType(L.accessType);
        setStreetParking(!!L.streetParking);
        setSchoolZone(!!L.schoolZone);
        setHasDogs(!!L.hasDogs);
        setGreenBin(!!L.greenBin);

        setServiceDay(L.serviceDay);
        setServiceTime(L.serviceTime);

        setTime(L.time);
        setFrequency(L.frequency);
        setRideOnOrPush(L.rideOnOrPush);
        setBagMulch(L.bagMulch);

        setFrontLawn(!!L.frontLawn);
        setRearLawn(!!L.rearLawn);
        setNatureStrip(!!L.natureStrip);
        setAcreage(!!L.acreage);

        setNewClient(!!L.newClient);
setLongTermClient(!!L.longTermClient);

        setDisclaimerAccepted(!!L.disclaimerAccepted);

        setLoading(false);
      } catch (err) {
        console.error(err);
        setMessage("❌ Server error loading listing");
      }
    }

    loadListing();
  }, [id]);

  // ======================================================
  // SAVE EDITED LISTING
  // ======================================================
  async function handleSave(e) {
    e.preventDefault();
    setMessage("");

    const payload = {
      suburb,
      state,
      postcode,
      accessType,
      streetParking,
      schoolZone,
      hasDogs,
      greenBin,
      serviceDay,
      serviceTime,
      time,
      frequency,
      rideOnOrPush,
      bagMulch,
      frontLawn,
      rearLawn,
      natureStrip,
      acreage,
      newClient,
  longTermClient,
      disclaimerAccepted,
    };

    try {
      const res = await axios.put(
        `${API_BASE_URL}/api/listings/edit/${id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!res.data.success) {
        setMessage(`❌ ${res.data.message}`);
        return;
      }

      setMessage("✅ Listing updated successfully!");
      setTimeout(() => navigate("/my-listings"), 600);

    } catch (err) {
      console.error(err);
      setMessage("❌ Error saving changes");
    }
  }

  if (loading) return <p style={{ padding: "20px" }}>Loading listing…</p>;

  // ======================================================
  // UI (IDENTICAL TO POST FORM, MINUS PRICE/CUT VALUE)
  // ======================================================

  return (
    <div style={containerStyle}>

      <h2 style={headerTitle}>Edit Listing</h2>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
            fontWeight: 600,
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSave} style={formStyle}>

        {/* LOCATION */}
        <h3 style={sectionHeader}>Location</h3>

        <label style={boldLabel}>Suburb:</label>
        <input style={inputStyle} value={suburb} onChange={(e) => setSuburb(e.target.value)} required />

        <label style={boldLabel}>State:</label>
        <select style={inputStyle} value={state} onChange={(e) => setState(e.target.value)} required>
          <option value="">Select</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="TAS">TAS</option>
          <option value="NT">NT</option>
          <option value="ACT">ACT</option>
        </select>

        <label style={boldLabel}>Postcode:</label>
        <input style={inputStyle} value={postcode} onChange={(e) => setPostcode(e.target.value)} required />

        {/* ACCESS */}
        <h3 style={sectionHeaderBlue}>Access & Parking</h3>

        <label style={boldLabel}>Access Type:</label>
        <select style={inputStyle} value={accessType} onChange={(e) => setAccessType(e.target.value)}>
          <option value="Access Available Anytime">Access Available Anytime</option>
          <option value="Access Requires Client to Be Home">Access Requires Client to Be Home</option>
          <option value="Access via Key or Gate Code">Access via Key or Gate Code</option>
        </select>

        <Checkbox label="Street Parking Available" value={streetParking} setValue={setStreetParking} />
        <Checkbox label="Located in a School Zone" value={schoolZone} setValue={setSchoolZone} />
        <Checkbox label="Dogs on Property" value={hasDogs} setValue={setHasDogs} />
        <Checkbox label="Green Bin Available" value={greenBin} setValue={setGreenBin} />

        {/* SERVICE */}
        <h3 style={sectionHeader}>Preferred Service</h3>

        <label style={boldLabel}>Preferred Day:</label>
        <select style={inputStyle} value={serviceDay} onChange={(e) => setServiceDay(e.target.value)}>
          <option value="any">Any Day</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
          <option value="saturday">Saturday</option>
          <option value="sundday">Sunday</option>
        </select>

        <label style={boldLabel}>Preferred Time:</label>
        <select style={inputStyle} value={serviceTime} onChange={(e) => setServiceTime(e.target.value)}>
          <option value="any">Any reasonable time</option>
          <option value="am">Morning (AM)</option>
          <option value="pm">Afternoon (PM)</option>
        </select>

        {/* JOB DETAILS */}
        <h3 style={sectionHeader}>Job Details</h3>

        <label style={boldLabel}>Estimated Time:</label>
        <select style={inputStyle} value={time} onChange={(e) => setTime(e.target.value)}>
          <option value="">Select</option>
          <option value="0.5">30 Minutes</option>
          <option value="1">1 Hour</option>
          <option value="1.5">1.5 Hours</option>
          <option value="2">2 Hours</option>
          <option value="3">3 Hours</option>
        </select>

        <label style={boldLabel}>Frequency:</label>
        <select style={inputStyle} value={frequency} onChange={(e) => setFrequency(e.target.value)}>
          <option value="weekly">Weekly</option>
          <option value="fortnightly">Fortnightly</option>
          <option value="3weeks">Every 3 Weeks</option>
          <option value="monthly">Monthly</option>
        </select>

        <label style={boldLabel}>Mower Type:</label>
        <select style={inputStyle} value={rideOnOrPush} onChange={(e) => setRideOnOrPush(e.target.value)}>
          <option value="Push">Push</option>
          <option value="Ride-on">Ride-on</option>
        </select>

        <label style={boldLabel}>Grass Handling:</label>
        <select style={inputStyle} value={bagMulch} onChange={(e) => setBagMulch(e.target.value)}>
          <option value="Mulch">Mulch</option>
          <option value="Bag">Bag</option>
        </select>

        {/* AREAS */}
        <h3 style={sectionHeader}>Areas Serviced</h3>

        <Checkbox label="Front Lawn" value={frontLawn} setValue={setFrontLawn} />
        <Checkbox label="Rear Lawn" value={rearLawn} setValue={setRearLawn} />
        <Checkbox label="Nature Strip" value={natureStrip} setValue={setNatureStrip} />
        <Checkbox
  label="Acreage Property"
  value={acreage}
  setValue={setAcreage}
/>

        {/* CLIENT HISTORY */}
<h3 style={sectionHeader}>Client History</h3>

<label style={labelStyle}>
  <input
    type="checkbox"
    checked={newClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setNewClient(checked);
      if (checked) setLongTermClient(false);
    }}
  />
  New client (under 6 months)
</label>

<label style={labelStyle}>
  <input
    type="checkbox"
    checked={longTermClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setLongTermClient(checked);
      if (checked) setNewClient(false);
    }}
  />
  Long-term client (12+ months)
</label>

        {/* DISCLAIMER */}
        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={disclaimerAccepted}
            onChange={(e) => setDisclaimerAccepted(e.target.checked)}
          />
          I confirm all details are accurate.
        </label>

        <button type="submit" style={buttonStyle}>
          Save Changes
        </button>

      </form>
    </div>
  );
}

function Checkbox({ label, value, setValue }) {
  return (
    <label style={labelStyle}>
      <input
        type="checkbox"
        checked={!!value}
        onChange={(e) => setValue(e.target.checked)}
      />
      {label}
    </label>
  );
}

// ====== Styles Matching Your Site ======
const containerStyle = {
  maxWidth: "95%",
  width: "600px",
  margin: "50px auto",
  padding: "25px",
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const headerTitle = {
  textAlign: "center",
  marginBottom: "25px",
  color: "#2e7d32",
};

const formStyle = { display: "flex", flexDirection: "column", gap: "18px" };

const inputStyle = {
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const labelStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const boldLabel = { fontWeight: "bold" };
const sectionHeader = { borderBottom: "2px solid #4caf50", paddingBottom: "5px" };
const sectionHeaderBlue = { borderBottom: "2px solid #0288d1", paddingBottom: "5px" };

const buttonStyle = {
  marginTop: "20px",
  padding: "15px",
  backgroundColor: "#4caf50",
  color: "#fff",
  fontWeight: "bold",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "1rem",
};

export default EditListing;
